import { atom, selector } from "recoil";

import {
  FilterChipNames,
  FilterChipsType,
  FilterInfoType,
  LabelType,
  FilterVaccinationIsolationType,
  FilterIsolationType,
  VaccinationType,
  Code,
} from "@types";
import { SortTypes } from "@constants";

export const sortTypeState = atom<SortTypes>({
  key: "sortType",
  default: SortTypes.favorite,
});

export const searchInputValueState = atom<string>({
  key: "searchInputValue",
  default: "",
});

export const filterVaccinationState = atom<VaccinationType | Code>({
  key: "filterVaccination",
  default: VaccinationType.all,
});

export const filterVaccinationIsolationState =
  atom<FilterVaccinationIsolationType>({
    key: "filterVaccinationIsolation",
    default: {
      CheckVaccinationEntrance: false,
      CheckVaccinationReturn: false,
      CheckUnVaccinationEntrance: false,
      CheckUnVaccinationReturn: false,
    },
  });

export const filterIsolationState = atom<FilterIsolationType>({
  key: "filterIsolation",
  default: {
    vaccinationEntrance: false,
    vaccinationReturn: false,
    unVaccinationEntrance: false,
    unVaccinationReturn: false,
  },
});

export const filterIsolationRefreshState = atom<boolean>({
  key: "filterIsolationRefresh",
  default: false,
});

export const filterChipsState = atom<FilterChipsType>({
  key: "filterChips",
  default: {
    isVaccine: false,
    isIsolate: false,
  },
});

export const filterTextState = selector<FilterInfoType[]>({
  key: "filterText",
  get: ({ get }) => {
    const nextFilterInfo: FilterInfoType[] = [
      {
        id: 2,
        filterName: FilterChipNames.isVaccination,
        icon: "ic_syringe_12x12_filled",
        active: false,
        label: LabelType.isVaccine,
      },
      {
        id: 3,
        filterName: FilterChipNames.isIsolation,
        icon: "ic_stayhome_12x12_filled",
        active: false,
        label: LabelType.isIsolate,
      },
    ];

    const vaccination = get(filterVaccinationState);
    const vaccineChip = FilterChipNames[vaccination];

    const isolation = get(filterIsolationState);
    const isolationEntrance =
      isolation.vaccinationEntrance || isolation.unVaccinationEntrance;
    const isolationReturn =
      isolation.vaccinationReturn || isolation.unVaccinationReturn;

    const isolationChip =
      isolationEntrance && isolationReturn
        ? FilterChipNames.entranceReturn
        : isolationEntrance
        ? FilterChipNames.entrance
        : isolationReturn
        ? FilterChipNames.return
        : FilterChipNames.isIsolation;

    nextFilterInfo[0].filterName = vaccineChip;
    nextFilterInfo[1].filterName = isolationChip;

    return nextFilterInfo;
  },
});

export const tabIndexState = atom<number>({
  key: "tabIndex",
  default: 0,
});
